module.exports = __webpack_public_path__ + "img/course.2789eea9.jpeg";